export const truncateLongText = (text: string, maxLength: number = 35) => {
  if (!text) return '';

  if (text.length > maxLength) {
    return String(text).substring(0, maxLength) + '...';
  }

  return text;
};
